/* eslint-disable max-len */
import React from "react";

import "./style.scss";
import { Button } from "@emisgroup/ui-button";
import { useTranslation } from "@emisgroup/acp-application-intl";
interface DataErrorProps {
  title: string;
  description: string;
  action: {
    title: string;
    icon: React.ReactNode;
    callback: () => void;
  };
}

export const DataError: React.FC<DataErrorProps> = ({ title, description, action }) => {
  const { t: translate } = useTranslation();
  return (
    <div className='error-container'>
      <div className="icon-container" data-size="medium" data-testid='errorContainer'>
        <svg viewBox="0 0 24 24" color="var(--primary)">
          <title data-testid='errorTitle'>{ translate("ErrorWhileLoadingData") }</title>
          <path fill="currentColor" d="M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24A6 6 0 0 1 5 12a5.99 5.99 0 0 1 4-5.65V4.26C5.55 5.15 3 8.27 3 12m8 5h2v-2h-2zM21 4h-6v6l2.24-2.24A6 6 0 0 1 19 12a5.99 5.99 0 0 1-4 5.65v2.09c3.45-.89 6-4.01 6-7.74c0-2.21-.91-4.2-2.36-5.64zm-10 9h2V7h-2z"></path>
        </svg>
      </div>
      <h3>{ title }</h3>
      <div className='data-error-message'>
        { description }
      </div>
      <div className='try-again'>
        <Button
          data-testid='tryAgain'
          variant='filled'
          onClick={ action.callback }>
          { action.icon }
          <span>{ action.title }</span>
        </Button>
      </div>
    </div>
  );
};
